const { Core, Events, Cache } = Global;
const { $fetch, $replaceContent, $toggleDisplay } = Global.Utils;

customElements.define('free-shipping-progress-bar', class extends Core {
    propTypes = {
        'cart-amount': Number,            // integer (e.g. in cents)
        'free-shipping-amount': Number,   // integer (e.g. in cents)
        'hide-on-complete': Boolean
    }

    elements = {
        $: [
            'progress',
            'msg-eligible',
            'msg-shortage'
        ],
    }

    render() {
        // No currency rate / conversion
        this.total = parseInt(this.prop('cart-amount'), 10) || 0;
        this.threshold = parseInt(this.prop('free-shipping-amount'), 10) || 0;

        this.diff = this.threshold - this.total;
        this.freeShipping = this.diff <= 0;
    }

    set freeShipping(isFree) {
        $toggleDisplay(this.$('msg-eligible'), isFree);
        $toggleDisplay(this.$('msg-shortage'), !isFree);

        if (this.prop('hide-on-complete')) {
            $toggleDisplay(this.$('progress'), !isFree);
        }

        this.$('progress').style.setProperty('--progress', Math.min(this.progress, 100));

        if (!isFree) {
            this.$remainingValue = this.$('msg-shortage').querySelector('[data-i18n-amount]');
            // diff is already an integer (e.g. cents), no extra conversion
            this.$remainingValue.innerHTML = Shopify.formatMoney(this.diff);
        }
    }

    get progress() {
        if (!this.threshold) return 0;
        return Math.round(this.total * 100 / this.threshold);
    }
});
